import { IdFilterType } from '../../../../../types';
import { GroupedItemBindingStatuses } from '../../../../../main/groupedItems/groupedItemsTypes';

export const enum UniversalFilterItemBindingStatusModes {
  // CONTAINS_ANY_OF = 'contains_any_of'
  CONTAINS_ALL_OF = 'contains_all_of'
  // CONTAINS_ONLY = 'contains_only',
  // CONTAINS_NONE_OF = 'contains_none_of',
  // DOES_NOT_CONTAIN_ANY_OF = 'does_not_contain_any_of',
  // IS_EMPTY = 'is_empty',
  // IS_NOT_EMPTY = 'is_not_empty'
}

export type UniversalFilterItemBindingStatusValue = IdFilterType;

export type UniversalFilterItemBindingStatusFilterState = {
  mode: UniversalFilterItemBindingStatusModes;
  bindingStatus?: GroupedItemBindingStatuses[];
};

// export type UniversalFilterItemBindingStatusFilterOptions = {};

export type UniversalFilterItemBindingStatusOnFilterStateChange = (
  state: UniversalFilterItemBindingStatusFilterState
) => void;

export type UniversalFilterItemBindingStatusOnChange = (
  value?: UniversalFilterItemBindingStatusValue
) => void;
